import React, { useEffect, useState } from "react";
import { User } from "lucide-react";
import { api, fileUrl } from "../lib/api";
import { PageHero, Empty } from "../components/ui-parts";

export default function Team() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/team").then(r => setList(r.data)); }, []);
  return (
    <div data-testid="team-page">
      <PageHero badge="Our Team" title="Office Bearers" subtitle="The people leading Jayatu Sanskrutam across Odisha." />
      <section className="section">
        <div className="container-narrow">
          {list.length === 0 ? <Empty title="Team profiles coming soon" hint="Admin can add team members from the dashboard." /> :
            <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
              {list.map(m => (
                <div key={m.id} className="js-card p-6 text-center" data-testid={`team-${m.id}`}>
                  {m.photo_url ? <img src={fileUrl(m.photo_url)} alt="" className="w-24 h-24 rounded-full mx-auto object-cover border border-[var(--js-border)]" /> : <div className="w-24 h-24 rounded-full mx-auto bg-[var(--js-bg)] border border-[var(--js-border)] flex items-center justify-center"><User /></div>}
                  <div className="font-heading text-lg text-[var(--js-primary)] mt-3">{m.name}</div>
                  <div className="text-xs text-[var(--js-muted)]">{m.designation}</div>
                  {m.bio && <p className="text-xs text-[var(--js-muted)] mt-3 line-clamp-3">{m.bio}</p>}
                </div>
              ))}
            </div>
          }
        </div>
      </section>
    </div>
  );
}
